import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-info-large",
  "use": "icon-info-large-usage",
  "viewBox": "0 0 180.579 166.105",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 180.579 166.105\" id=\"icon-info-large\">\n<rect id=\"icon-info-large_backgroundrect\" fill=\"none\" width=\"180.579\" height=\"166.105\" />\n<g>\n\t<title>Layer 1</title>\n\t<path id=\"icon-info-large_svg_1\" fill=\"none\" d=\"M3.29,2.632H179.92v161.5H3.29V2.632z\" />\n\t<path id=\"icon-info-large_svg_2\" fill=\"#EDEDED\" d=\"M82.217,117.329h14.171v-43.5H82.217V117.329z M89.303,8.579\n\t\tc-39.112,0-70.855,32.48-70.855,72.5c0,40.021,31.743,72.5,70.855,72.5c39.112,0,70.855-32.479,70.855-72.5\n\t\tC160.158,41.059,128.415,8.579,89.303,8.579z M89.303,139.079c-31.247,0-56.684-26.028-56.684-58c0-31.973,25.437-58,56.684-58\n\t\tc31.247,0,56.684,26.027,56.684,58C145.987,113.051,120.549,139.079,89.303,139.079z M82.217,59.329h14.171v-14.5H82.217V59.329z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/info-large.svg
// module id = 2/qn
// module chunks = 28